export function formatMoney(
  amount: number,
  options?: {
    showDollarSign?: boolean;
    showMagnitudeUnit?: boolean;
    showCommas?: boolean;
  },
): string {
  const showDollarSign =
    options?.showDollarSign ?? defaultOptions.showDollarSign;

  const showMagnitudeUnit =
    options?.showMagnitudeUnit ?? defaultOptions.showMagnitudeUnit;

  const showCommas = options?.showCommas ?? defaultOptions.showCommas;

  // https://stackoverflow.com/a/2901298
  let formatted = (amount / 1000).toFixed(0).toString();

  if (showCommas) {
    formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  if (showDollarSign) {
    formatted = "$" + formatted;
  }

  if (showMagnitudeUnit) {
    if (Math.abs(amount) < 1000 && amount !== 0) {
      formatted = "<$1k";
    } else {
      formatted += "k";
    }
  }

  return formatted;
}

export function parseFormattedMoney(amount: string): number {
  if (amount.endsWith("K") || amount.endsWith("k")) {
    return 1000 * parseFormattedMoney(amount.substring(0, amount.length - 1));
  } else if (amount.endsWith("M") || amount.endsWith("m")) {
    return 1e6 * parseFormattedMoney(amount.substring(0, amount.length - 1));
  } else if (amount.endsWith("B") || amount.endsWith("b")) {
    return 1e9 * parseFormattedMoney(amount.substring(0, amount.length - 1));
  } else {
    // eslint-disable-next-line no-useless-escape
    const withoutDollarSignAndCommas = amount.replace(/[^\d\.-]/g, "");
    return parseFloat(withoutDollarSignAndCommas);
  }
}

const defaultOptions = {
  showDollarSign: true,
  showMagnitudeUnit: true,
  showCommas: true,
};
